import React, { Component } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import { ConfirmationModal } from "../UI/ConfirmationModal/ConfirmationModal";
import { getMessagemErro } from "../../utils/erro";
import { formataData } from "../../utils/formatadorData";
import api from "../../services/api";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		filters: state.filterStore,
	}
}

const initialState = {
	resultadoPesquisa: [],
	nome: "",
	pesquisaExecutada: false,
	botoesHabilitados: true,
	exibeModalConfirmacao: false,
	idParaRemover: null,
};

export const BlacklistGrandesVolumesList =

// router
withRouter(
// redux
connect(
	(mapStateToProps),
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = initialState;

			this.handleInputChange = this.handleInputChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.confirmaRemocao = this.confirmaRemocao.bind(this);
			this.remover = this.remover.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />

					<div style={{margin: "10px"}}>
						<h1>Blacklist Dinâmica de Arquivos de Grandes Volumes</h1>
					</div>

					<div className="div-form">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada, nome } = this.state;
			const { content } = resultadoPesquisa;

			return(
				<div className="container-fluid">
					<ConfirmationModal
						isOpen={this.state.exibeModalConfirmacao}
						onClose={this.fechaModal}
						onConfirm={this.remover}
						message="Deseja realmente remover esta entrada de blacklist?"
					/>

					<div className="br-form">
						<div className="row">
							<div className="col-md">
								<div className="field">
									<div className="input">
										<label htmlFor="nome">Nome:</label>
										<input type="text" name="nome"
											value={nome}
											onChange={this.handleInputChange}
											maxLength="100"/>
									</div>
								</div>
							</div>
						</div>
						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={() => this.pesquisar()} disabled={!this.state.botoesHabilitados}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()} disabled={!this.state.botoesHabilitados}>Limpar</button>
								<Link to="/blacklist-arquivo-gv/new">
									<button type="button" className="button is-secondary mr-3" disabled={!this.state.botoesHabilitados}>Incluir</button>
								</Link>
								<ButtonBack disabled={!this.state.botoesHabilitados} />
							</div>
						</div>

						{(content && content.length > 0) &&
							<div className="br-table">
								<div className="table">
									<table>
										<thead>
											<tr>
												<th scope="col">Padrão</th>
												<th scope="col">Status</th>
												<th scope="col">Observação</th>
												<th scope="col">Criado em</th>
												<th scope="col">Criado por</th>
												<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										<tbody>
											{content.map((entrada, index) =>
												<tr key={index}>
													<td>{entrada.padrao}</td>
													<td>{entrada.ativo ? 'Ativo' : 'Inativo'}</td>
													<td>{entrada.observacao}</td>
													<td>{formataData(entrada.dataCriacao)}</td>
													<td>{entrada.usuarioCriacao}</td>
													<td className="text-center">
														{entrada.ativo &&
															<div className="actions">
																<button type="button" title="Remover entrada" onClick={() => this.confirmaRemocao(entrada.id)}>
																	<span className="sr-only">Remover</span>
																	<i className="fas fa-trash"></i>
																</button>
															</div>
														}
													</td>
												</tr>
											)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (!content || content.length === 0)) &&
							<div>
								Nenhuma entrada de blacklist encontrada com os critérios informados.
							</div>
						}
					</div>
				</div>
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.value;
			this.setState({[nome]: valor});
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];

			this.setState({
				...initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: []
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar(e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				});
			}
		}

		executaPesquisaPaginada(pagina){
			const { nome } = this.state;
			const url = '/api/blacklist-arquivo-gv/paginado';

			const criterioPesquisa = {
				nome: nome,
				pagina: pagina,
			}

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando();
			api(options)
				.then(response => {
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada: true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					})
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar as entradas de blacklist.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.setState(initialState, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}

		confirmaRemocao(id){
			this.setState({
				exibeModalConfirmacao: true,
				idParaRemover: id,
			});
		}

		remover(){
			const { idParaRemover, resultadoPesquisa } = this.state;
			this.fechaModal();

			this.props.mostraAguardando();
			api.delete(`/api/blacklist-arquivo-gv/${idParaRemover}`)
				.then(() => {
					this.props.exibeMensagemSucesso("Entrada de blacklist removida com sucesso.");
					this.executaPesquisaPaginada(resultadoPesquisa.number || 0);
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível remover a entrada de blacklist.", erro);
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				})
				.then(() => {
					this.props.escondeAguardando();
				});
		}

		fechaModal(){
			this.setState({
				exibeModalConfirmacao: false,
				idParaRemover: null,
			});
		}
	}

) // redux
); // router
